import { FaUser } from "react-icons/fa";
import { BiSolidTruck } from "react-icons/bi";
import { useState } from "react";
import { useRef } from "react";
import { useEffect } from "react";
import style from "./LoginUserMenu.module.css";
import { ImExit } from "react-icons/im";
import Swal from "sweetalert2";
import { Link, useNavigate } from "react-router-dom";
import useSharedData from "../../../../../../hooks/useSharedData";

function LoginUserMenu() {
  const navigate = useNavigate();

  const { user, isAgent } = useSharedData();
  const token = localStorage.getItem("token");
  const city = user?.address?.city?.faName ?? "";
  const fullName = user?.name + " " + (user?.family ?? "");

  const [show, setShow] = useState(false);
  const userIcon = useRef(null);

  useEffect(() => {
    const handleClickOutside = e => {
      if (userIcon.current && !userIcon.current.contains(e.target)) {
        setShow(() => false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [userIcon]);

  const handleExit = () => {
    Swal.fire({
      icon: "error",
      title: "خروج",
      html: "<p style='font-size: 20px'>آیا مطمئن هستید ؟؟</p>",
      confirmButtonText: "بله",
      showCancelButton: true,
      cancelButtonText: "خیر",
      confirmButtonColor: "red",
      iconColor: "red",
    }).then(result => {
      if (result.isConfirmed) {
        navigate("/logout");
      }
    });
  };

  return (
    <div className="position-relative d-none d-sm-block" ref={userIcon}>
      <button className={style.user} onClick={() => setShow(cur => !cur)}>
        <FaUser />
      </button>
      {show && (
        <div className={style.userList}>
          <article className="d-flex column-gap-3">
            <img src="/avatar.png" alt="" className={style.img} />
            <div className="d-flex justify-content-center flex-column">
              <p className="mb-0 text-end fs-6 fw-semibold">{fullName}</p>
              <p className="mb-0 text-end">{city}</p>
            </div>
          </article>
          <div className={style.line} />
          <ul className={style.list}>
            {isAgent && (
              <li>
                <Link
                  to={`https://agent.avaex.ir/tokenLogin/${token}`}
                  className="text-decoration-none"
                >
                  <span>
                    <BiSolidTruck />
                  </span>
                  <span>پنل نمایندگی</span>
                </Link>
              </li>
            )}
            <li>
              <button onClick={handleExit}>
                <span>
                  <ImExit />
                </span>
                <span>خروج</span>
              </button>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
}

export default LoginUserMenu;
